export class IsDisableFlagVM {
    JobId : number;
    //LoggedInResourceID :  number | null;
    IsDisableAddBooking:boolean;
    IsDisableDeleteBooking: boolean;   
  //LoggedInResourceEmail: number;
  IsDisabledReplaceAllFlag : any;
  InstanceId: number;
}